import $ from 'jquery'

const toc = $('.oreca-toc')

if (toc.length) {
  const headings = $('.entry-content h2, .entry-content h3, .entry-content h4, .entry-content h5, .entry-content h6')
  if (headings.length) {
    const list = toc.find('ul')
    headings.map((index, heading) => {
      if (heading) {
        heading.id = `toc-${index}`
        list.append(`<li><a href="#toc-${index}">${heading.innerText}</a></li>`)
      }
    })
  }
}